import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IDispositionskennzeichen } from '../_interfaces/dispositionskennzeichen';
import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class DispositionskennzeichenService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'nrVersorgungsunternehmen', type: 'string'},
    {name: 'art', type: 'string'},
    {name: 'kennzeichenNr', type: 'int'},
    {name: 'bezeichnung', type: 'string'}
  ];
    
  private dispositionskennzeichenCache = new Map<string, IDispositionskennzeichen[]>();
  private behaelterkennzeichenCache = new Map<string, IDispositionskennzeichen[]>();

  getDispositionskennzeichenForVersorgungsunternehmen(vu: string, art: string): Observable<{ dispositionskennzeichen: IDispositionskennzeichen[] }> {
    // Prüfe ob es schon im Cache ist
    let cache: Map<string, IDispositionskennzeichen[]> = null;
    //console.log("DispositionskennzeichenService.getDispositionskennzeichenForVersorgungsunternehmen() checking cache:", cache);

    if(art == 'B') { // Behälter
      cache = this.dispositionskennzeichenCache;
    }
    else {
      cache = this.behaelterkennzeichenCache;
    }
    if (cache.has(vu)) {
      console.log("DispositionskennzeichenService.getDispositionskennzeichenForVersorgungsunternehmen() return from cache:", cache);
      return of({
       dispositionskennzeichen: cache.get(vu)!
      });
    }

    return this.httpClient.get(this.apiBaseUrl + 'dispositionskennzeichen?vu=' + vu + '&art=' + art, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          // Speichere im Cache
          cache.set(vu, <IDispositionskennzeichen[]>response.body );
          //console.log("DispositionskennzeichenService.getDispositionskennzeichenForVersorgungsunternehmen() updated cache:", cache);

          return { dispositionskennzeichen: <IDispositionskennzeichen[]>response.body };
        }), catchError(this.handleError))
  }

  initializeDispositionskennzeichen(): IDispositionskennzeichen {
    return {
      id: 0,
      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      nrVersorgungsunternehmen: '',
      art: '',
      kennzeichenNr: 0,
      bezeichnung: ''
    };
  }


}
